import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { Link } from "react-router-dom";

/**
 * WrongBankDetail component displays an error message for invalid bank details.
 * Shows entered details and provides navigation to edit them.
 */
const WrongBankDetail = ({ login = null }) => {
  const location = useLocation();
  // const { userId } = useParams();

  const bankdetails = location.state?.bankdetails || "";
  const userId = location.state?.userId || "";
  const [redirectUrl,] = useState(login ? 'customer' : 'customerCard')

  return (
    <>
      <div className="container vh-100 mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="40%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/new1-error.png")}
              />
              <h6 className="mt-5">Bank is not Valid</h6>
            </div>

            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>Name At Bank</label>
              <p>{bankdetails.name}</p>
              <label>Account Number</label>
              <p>{bankdetails.account_number}</p>
              <label>IFSC</label>
              <p>{bankdetails.ifsc_code}</p>
            </div>

            <div className="btns text-center cn-btn mt-15 d-flex align-items-center">
              <Link to={`/${redirectUrl}/addbank-account/${userId}`}>
                <button
                  type="button"
                  className="btn bgdark-blue text-white"
                // onClick={handleEditClick}
                >
                  Edit
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WrongBankDetail;
